import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

export const Columns = ({ openConfirm, pendingList, role }) => {

  const hasRole = (role === 'Master' || role === 'Admin - Comercial' || role === 'Admin - sourcing')

  return [
    "Id",
    {
      name: "Título",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => (
          pendingList().includes(tableMeta.rowData[0])
            ? <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
              <span style={{ marginRight: '1em' }}>{value}</span>
              {!hasRole && <Tooltip title={'Clique aqui para assinar'} placement={'top'}>
                <button onClick={(event) => {
                  event.stopPropagation();
                  openConfirm(tableMeta.rowData[0])
                }}>
                  <FontAwesomeIcon icon={faExclamationCircle} size='2x' style={{ color: '#FEBC28' }} />
                </button>
              </Tooltip>}
            </div>
            : value
        )
      }
    },
    "Descrição",
    "Data inicio vigência",
    "Data fim vigência",
    "Data de Assinatura"
  ];
};